import React from 'react';
import { ArrowDown } from 'lucide-react';
import { companyInfo } from '../data/mock';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const element = document.querySelector('#about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-white overflow-hidden"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, black 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 md:px-10 text-center">
        {/* Logo */}
        <div className="mb-12 flex justify-center">
          <img
            src={companyInfo.logo}
            alt={companyInfo.name}
            className="h-32 md:h-40 lg:h-48 w-auto"
          />
        </div>

        {/* Headline */}
        <h1 className="text-black text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-bold tracking-tight mb-6 uppercase leading-none">
          {companyInfo.heroHeadline}
        </h1>

        {/* Subheadline */}
        <p className="text-gray-600 text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto mb-12 font-light leading-relaxed">
          {companyInfo.heroSubheadline}
        </p>

        {/* CTA Button */}
        <button
          onClick={scrollToContact}
          className="inline-flex items-center gap-3 border-2 border-black text-black px-8 py-4 text-sm font-semibold uppercase tracking-widest hover:bg-black hover:text-white transition-all duration-300 group"
        >
          AR Tarım ile İletişime Geçin
          <ArrowDown className="w-4 h-4 group-hover:translate-y-1 transition-transform" />
        </button>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToAbout}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 text-gray-400 hover:text-black transition-colors cursor-pointer"
        aria-label="Scroll down"
      >
        <div className="flex flex-col items-center gap-2">
          <span className="text-xs uppercase tracking-widest">Keşfet</span>
          <ArrowDown className="w-5 h-5 animate-bounce" />
        </div>
      </button>
    </section>
  );
};

export default HeroSection;
